import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import { MdGroups } from "react-icons/md";
import ModalDetailsContent from "./modal-details-content.jsx";

const BASENAME = import.meta.env.BASE_URL;

const DetailsContent = ({ data, boName, hasPermission }) => {
    const [limit, setLimit] = useState(10);
    const passedLimit = data?.length > limit;
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const seeMoreOrLess = () => {
        setLimit(prev => prev ? null : 10);
    };

    useEffect(() => {
        let values = [];

        data.map(element => {
           values.push([
               element.type,
               element.qty,
               element.bo_ids,
           ]);
        });

        ReportUtils.createExportableTable(["Tipo de apreensão", "Quantidade", `${boName}`], values, `Detalhamento ${boName}`, "bo-apprehensions-detail-data");
    }, [data]);

    if (!data?.length) {
        return (
            <div className="chart-report">
                <span className="chart-title"> Apreensões por {boName} </span>

                <div className="alert alert-info p-2 h6 text-center mt-3">
                    Nenhum registro encontrado no período informado.
                </div>
            </div>
        );
    }

    const detailsModal = (item) => {
        setSelectedItem({
            ...item,
            ind_info: JSON.parse(item.ind_info || "[]")
        });

        setOpen(true);
    };

    return (
        <div className="chart-report" id="individual-details">
            <div className="report-divisor mb-6"> <span className="divisor-title">DETALHAMENTO</span></div>

            <div className="mt-3 mb-6">
                <table id="bo-apprehensions-detail-data" className="table report-table" sheet-name={`Apreensões por ${boName}`}>

                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            <th className="w-[20%]">Tipo de apreensão</th>
                            <th className="w-[15%]">Quantidade</th>
                            <th className="w-[60%]">{boName}</th>
                            <th className="w-[5%] text-right"></th>
                        </tr>
                    </thead>

                    <tbody className="bg-white">
                        { (limit ? data.slice(0, limit) : data).map((element, index) => {
                            const individuals = JSON.parse(element.ind_info);

                            const hasIndividuals = individuals.some(ind => {
                                const cpf = (ind?.cpf ?? "").trim();
                                const name = (ind?.name ?? "").trim();

                                return ((cpf !== "" && cpf !== "[]") || (name !== "" && name !== "[]"));
                            });

                            return (
                                <tr key={index}>
                                    <td className="w-[20%]">{element.type}</td>
                                    <td className="w-[15%]">{element.qty}</td>
                                    <td className="w-[60%]">
                                        {element.bo_ids?.split(',')?.map((id) => id.trim())?.map((id, index, array) => {
                                            const ids = id.replace('/', '-').replace(' ', '');

                                            return (
                                                <React.Fragment key={`${id}-${index}`}>
                                                    {hasPermission ? (<a href={`${BASENAME}bo/redirect/${ids}`} target={"_blank"} className={'inner-link'} title={`Acessar ${boName} - ${id}`}>{id}</a>) : (<span>{id}</span>)}
                                                    {index !== array.length - 1 && ', '}
                                                </React.Fragment>
                                            );
                                        })}
                                    </td>

                                    { hasIndividuals ? (
                                        <td className="w-[5%]"><MdGroups size={20} title={'Lista de indivíduos envolvidos'} className={'details-link'} onClick={() => detailsModal(element)}/></td>
                                    ) : (
                                        <td className="w-[5%] text-[#8F8F8F]"><MdGroups size={20} className={'opacity-25! cursor-not-allowed'} title={'Não há indivíduos envolvidos'}/></td>
                                    )}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

                { open && selectedItem && (
                    <ModalDetailsContent open={open} setOpen={setOpen} data={selectedItem} boName={boName} hasPermission={hasPermission}/>
                )}

            </div>
        </div>
    );
};

export default DetailsContent;